// document.addEventListener("click", function (event) {
//   if (
//     event.target.matches(".size_option_swatch") ||
//     event.target.closest(".size_option_swatch")
//   ) {
//     if (event.target.closest(".product-card-wrapper")) {
//       const size = event.target.matches(".size_option_swatch")
//         ? event.target
//         : event.target.closest(".size_option_swatch");
//       const parent = event.target.closest(".product-card-wrapper");
//       const ATCbtn = parent.querySelector(".atc_btn_card");
//       const sizes = parent.querySelectorAll(".size_option_swatch");
//       sizes?.forEach((btn) => btn.classList.remove("active"));
//       size.classList.add("active");
//       const id = parseInt(size.getAttribute("data-id"));
//       const BIStrigger = size
//         .closest(".product-card-wrapper")
//         ?.querySelector(".BIS_trigger");
//       const select = size
//         .closest(".product-card-wrapper")
//         ?.querySelector('.ProductForm select[name="id"]');
//       if (size.classList.contains("out_of_stock")) {
//         BIStrigger.style.display = "";
//       } else {
//         BIStrigger.style.display = "none";
//         window.updateCartDrawer(id);
//         document.querySelector("#cart-icon-bubble")?.click();
//       }
//       BIStrigger.setAttribute("data-variant-id", id);
//       select.querySelector("option[selected]")?.removeAttribute("selected");
//       select
//         .querySelector('option[value="' + id + '"]')
//         ?.setAttribute("selected", "selected");
//     } else if (event.target.closest(".mobile_size_swatch_popup")) {
//       const target = event.target.matches(".size_option_swatch")
//         ? event.target
//         : event.target.closest(".size_option_swatch");
//       const parent = event.target.closest(".mobile_size_swatch_popup");
//       const ATCbtn = parent.querySelector(".atc_btn_card");
//       const BICBTN = parent.querySelector(".BIS_trigger");
//       const sizes = parent.querySelectorAll(".size_option_swatch");
//       sizes?.forEach((btn) => btn.classList.remove("active"));
//       const id = parseInt(target.getAttribute("data-id"));
//       ATCbtn.removeAttribute("disabled");
//       ATCbtn.setAttribute("data-id", id);
//       BICBTN.setAttribute("data-variant-id", id);
//       target.classList.add("active");
//       if (target.classList.contains("out_of_stock")) {
//         ATCbtn.textContent = "Sold out";
//         ATCbtn.style.display = "none";
//         BICBTN.style.display = "";
//       } else {
//         ATCbtn.textContent = "Add To Cart";
//         ATCbtn.style.display = "";
//         BICBTN.style.display = "none";
//       }
//     }
//   }
//   if (
//     event.target.matches(".mobile__Bis") ||
//     event.target.closest(".mobile__Bis")
//   ) {
//     const parentBisTrgt = event.target.closest(".mobile_size_swatch_popup");
//     if (parentBisTrgt) {
//       parentBisTrgt.style.display = "none";
//     }
//   }

//   if (
//     event.target.matches(".quick_add_bag") ||
//     event.target.closest(".quick_add_bag")
//   ) {
//     if (event.target.closest(".card_size_swatches")) {
//       const SwatchesWrapper = event.target.closest(".card_size_swatches");
//       const target = event.target.matches(".quick_add_bag")
//         ? event.target
//         : event.target.closest(".quick_add_bag");
//       const sizes = SwatchesWrapper.querySelector(".info_size_swatces");
//       const name = target.getAttribute("data-title");
//       const color = target.getAttribute("data-color");
//       const BIS = SwatchesWrapper.querySelector(".mobile_bis");
//       window.createMobilePopup(name, color, sizes, BIS);
//     }
//   }
//   if (
//     event.target.matches(".overlay_wrapper_swatches") ||
//     event.target.closest(".close_btn_popup") ||
//     event.target.matches(".close_btn_popup")
//   ) {
//     if (event.target.closest(".mobile_size_swatch_popup")) {
//       event.target.closest(".mobile_size_swatch_popup")?.remove();
//     }
//   }
//   if (
//     event.target.matches(".atc_btn_card") ||
//     event.target.closest(".atc_btn_card")
//   ) {
//     const target = event.target.matches(".atc_btn_card")
//       ? event.target
//       : event.target.closest(".atc_btn_card");
//     const id = parseInt(target.getAttribute("data-id"));
//     target?.classList.add("loading");
//     window.updateCartDrawer(id, target);
//     document.querySelector("#cart-icon-bubble")?.click();
//   }
// });
document.addEventListener("click", function (event) {
  if (
    event.target.matches(".size_option_swatch") ||
    event.target.closest(".size_option_swatch")
  ) {
    if (event.target.closest(".product-card-wrapper")) {
      const size = event.target.matches(".size_option_swatch")
        ? event.target
        : event.target.closest(".size_option_swatch");
      const parent = event.target.closest(".product-card-wrapper");
      const ATCbtn = parent.querySelector(".atc_btn_card");
      const sizes = parent.querySelectorAll(".size_option_swatch");
      sizes?.forEach((btn) => btn.classList.remove("active"));
      size.classList.add("active");
      const id = parseInt(size.getAttribute("data-id"));
      const BIStrigger = size
        .closest(".product-card-wrapper")
        ?.querySelector(".BIS_trigger");
      const select = size
        .closest(".product-card-wrapper")
        ?.querySelector('.ProductForm select[name="id"]');
      if (size.classList.contains("out_of_stock")) {
        BIStrigger.style.display = "";
        const baseUrl = BIStrigger.getAttribute("href").split("?")[0];
        BIStrigger.setAttribute(
          "href",
          `${baseUrl}?view=stock-popup&variant=${id}`
        );
      } else {
        BIStrigger.style.display = "none";
        window.updateCartDrawer(id);
        document.querySelector("#cart-icon-bubble")?.click();
      }
      BIStrigger.setAttribute("data-variant-id", id);
      select.querySelector("option[selected]")?.removeAttribute("selected");
      select
        .querySelector('option[value="' + id + '"]')
        ?.setAttribute("selected", "selected");
    } else if (event.target.closest(".mobile_size_swatch_popup")) {
      const target = event.target.matches(".size_option_swatch")
        ? event.target
        : event.target.closest(".size_option_swatch");
      const parent = event.target.closest(".mobile_size_swatch_popup");
      const ATCbtn = parent.querySelector(".atc_btn_card");
      const BICBTN = parent.querySelector(".BIS_trigger");
      const sizes = parent.querySelectorAll(".size_option_swatch");
      sizes?.forEach((btn) => btn.classList.remove("active"));
      const id = parseInt(target.getAttribute("data-id"));
      ATCbtn.removeAttribute("disabled");
      ATCbtn.setAttribute("data-id", id);
      BICBTN.setAttribute("data-variant-id", id);
      target.classList.add("active");
      if (target.classList.contains("out_of_stock")) {
        ATCbtn.textContent = "Sold out";
        ATCbtn.style.display = "none";
        BICBTN.style.display = "";
        const baseUrl = BICBTN.getAttribute("href").split("?")[0];
        BICBTN.setAttribute(
          "href",
          `${baseUrl}?view=stock-popup&variant=${id}`
        );
      } else {
        ATCbtn.textContent = "Add To Cart";
        ATCbtn.style.display = "";
        BICBTN.style.display = "none";
      }
    }
  }
  if (
    event.target.matches(".mobile__Bis") ||
    event.target.closest(".mobile__Bis")
  ) {
    const parentBisTrgt = event.target.closest(".mobile_size_swatch_popup");
    if (parentBisTrgt) {
      parentBisTrgt.style.display = "none";
    }
  }

  if (
    event.target.matches(".quick_add_bag") ||
    event.target.closest(".quick_add_bag")
  ) {
    if (event.target.closest(".card_size_swatches")) {
      const SwatchesWrapper = event.target.closest(".card_size_swatches");
      const target = event.target.matches(".quick_add_bag")
        ? event.target
        : event.target.closest(".quick_add_bag");
      const sizes = SwatchesWrapper.querySelector(".info_size_swatces");
      const name = target.getAttribute("data-title");
      const color = target.getAttribute("data-color");
      const BIS = SwatchesWrapper.querySelector(".mobile_bis");
      window.createMobilePopup(name, color, sizes, BIS);
    }
  }
  if (
    event.target.matches(".overlay_wrapper_swatches") ||
    event.target.closest(".close_btn_popup") ||
    event.target.matches(".close_btn_popup")
  ) {
    if (event.target.closest(".mobile_size_swatch_popup")) {
      event.target.closest(".mobile_size_swatch_popup")?.remove();
    }
  }
  if (
    event.target.matches(".atc_btn_card") ||
    event.target.closest(".atc_btn_card")
  ) {
    const target = event.target.matches(".atc_btn_card")
      ? event.target
      : event.target.closest(".atc_btn_card");
    const id = parseInt(target.getAttribute("data-id"));
    target?.classList.add("loading");
    window.updateCartDrawer(id, target);
    document.querySelector("#cart-icon-bubble")?.click();
  }

  // if (
  //   event.target.matches(".svg__icon") ||
  //   event.target.closest(".svg__icon")
  // ) {
  //   const target = event.target.matches(".svg__icon")
  //     ? event.target
  //     : event.target.closest(".svg__icon");
  //   const newDataId = target.closest('.custom_text_cards')
  //   const id = parseInt(newDataId.getAttribute("data-variant_id"));
  //   target?.classList.add("loading");
  //   window.updateCartDrawer(id, target);
  //   document.querySelector("#cart-icon-bubble")?.click();
  // }
});

window.updateCartDrawer = function (id, target) {
  if (id) {
    function getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
    const config = {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/javascript",
      },
    };

    const sectionsToRender = [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cartIconBubble",
        section: "cart-icon-bubble",
        selector: ".cart-count-section",
      },
    ];

    let formData = new FormData();
    formData.append("id", id);
    formData.append("quantity", 1);
    formData.append(
      "sections",
      sectionsToRender.map((section) => section.section)
    );
    formData.append("sections_url", window.location.pathname);
    config.body = formData;

    fetch(`/cart/add`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.message);
          return;
        }

        const product = response.hasOwnProperty("items")
          ? response.items[0]
          : response;
        document.querySelector("cart-drawer")?.classList.remove("is-empty");
        target?.classList.remove("loading");
        document.querySelector(".mobile_size_swatch_popup")?.remove();
        sectionsToRender.forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          console.log("sectionElement", sectionElement);
          if (sectionElement) {
            sectionElement.innerHTML = getSectionInnerHTML(
              response.sections[section.section],
              section.selector
            );
          }
        });
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  } else {
    console.log("No matching variant found.");
  }
};

window.createMobilePopup = function (name, color, sizes, BIS) {
  const html = `
    <div class="popup_wrapper_mobile_swatches">
      <div class="overlay_wrapper_swatches">&nbsp;</div>
      <div class="content_wrapper_swatches_size_mobile">
      <div class="logo_wp">
          <img src="https://cdn.shopify.com/s/files/1/0538/0485/9592/files/9841_New_logo_white_copy_1_222e2c43-df8b-4526-b90b-6d5a91b9e512.webp?v=1745582087">
        </div>
        <h4 class="products_name_wrapper">${name}</h4>
        ${color !== "" ? `<h4 class="color_name_swatch">${color}</h4>` : ""}
        ${sizes ? sizes.innerHTML : ""}
        ${
          sizes !== ""
            ? `<button class="atc_btn_card disable_btn" data-id="" disabled>Select an option</button>`
            : ""
        }
        ${BIS ? BIS.innerHTML : ""}
          <a href="javascript:void(0);" class="close_btn_popup">
            <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M32 1.8854L30.1146 0L16 14.1146L1.8854 0L0 1.8854L14.1146 16L0 30.1146L1.8854 32L16 17.8854L30.1146 32L32 30.1146L17.8854 16L32 1.8854Z" fill="#fff"></path>
            </svg>
          </a>
      </div>
    </div>
  `;

  const popup = document.createElement("div");
  popup.classList.add("mobile_size_swatch_popup");
  popup.innerHTML = html;

  document.body.appendChild(popup);
};
//==================


document.addEventListener("click", function (event) {
  if (
    event.target.matches(".pgn-LoadMore") ||
    event.target.closest(".pgn-LoadMore")
  ) {
    event.preventDefault()
    loadManualy(event)
  }
  if (
    event.target.matches(".pgn-Loadprev") ||
    event.target.closest(".pgn-Loadprev")
  ) {
    const target = event.target.matches(".pgn-Loadprev")
        ? event.target
        : event.target.closest(".pgn-Loadprev");
    event.preventDefault()
    const previousPage = parseInt(target.getAttribute('data-current-page')) 
    loadPreviousProducts(previousPage , target) 
  }
});
async function loadManualy(event){
    await loadMoreProducts()
    setTimeout(function(){
    event.target.closest(".pgn-LoadMore").style.display = 'none';
    event.target.closest('.collection').querySelector('#infinite-scroll-trigger').style.display = 'block';
    }, 500)
}
function updateLoadingEl(updatedHtml) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(updatedHtml, "text/html");
  
  const infiniteEl = document.getElementById("infinite-scroll-trigger");
  const loadMore = document.querySelector(".pgn-LoadMore");
  const loadPrev = document.querySelector(".pgn-Loadprev");
  
  // Get updated elements from the new HTML
  const newInfiniteEl = doc.getElementById("infinite-scroll-trigger");
  const newLoadMore = doc.querySelector(".pgn-LoadMore");
  const newLoadPrev = doc.querySelector(".pgn-Loadprev");
  
  // Update infinite scroll trigger attributes
  if (infiniteEl && newInfiniteEl) {
    Array.from(newInfiniteEl.attributes).forEach(attr => {
      if (attr.name !== 'class' && attr.name !== 'id') {
        infiniteEl.setAttribute(attr.name, attr.value);
      }
    });
  }
  
  // Update load more button attributes
  if (loadMore && newLoadMore) {
    Array.from(newLoadMore.attributes).forEach(attr => {
      if (attr.name !== 'class' && attr.name !== 'id') {
        loadMore.setAttribute(attr.name, attr.value);
      }
    });
  }
  
  // Update load previous button attributes
  if (loadPrev && newLoadPrev) {
    Array.from(newLoadPrev.attributes).forEach(attr => {
      if (attr.name !== 'class' && attr.name !== 'id') {
        loadPrev.setAttribute(attr.name, attr.value);
      }
    });
  }
}
function getCurrentPageFromURL() {
  const trigger = document.getElementById("infinite-scroll-trigger");
  return parseInt(trigger.getAttribute("data-current-page")) || 1;
}

function getTotalPages(trigger) {
  return parseInt(trigger.getAttribute("data-total-pages")) || 1;
}
async function loadMoreProducts() {
  const trigger = document.getElementById("infinite-scroll-trigger");
  const productsGrid = document.querySelector(".products-list-grid");
  const sectionId = trigger.getAttribute("data-section-id");
  let currentPage = getCurrentPageFromURL();
  const totalPages = getTotalPages(trigger);

  if (currentPage >= totalPages) return;

  currentPage++;
  trigger.setAttribute("data-current-page", currentPage);

  const url = new URL(window.location.href);
  url.searchParams.set("page", currentPage);
  if (sectionId) url.searchParams.set("section_id", sectionId);

  const browserUrl = new URL(window.location.href);
  browserUrl.searchParams.set("page", currentPage);
  window.history.replaceState({}, "", browserUrl.toString());
  trigger.classList.add("is-loading");

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Network error");

    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    const newContent = doc.querySelector(".products-list-grid");
    // updateLoadingEl(text)
    if (newContent) {
      Array.from(newContent.children).forEach((el) => {
        productsGrid.appendChild(el);
      });
    }
  } catch (err) {
    console.error("Failed to load more products", err);
  } finally {
    setTimeout(() => {
      trigger.classList.remove("is-loading");
    }, 300);
  }
}
async function loadPreviousProducts(previousPage, trigger, menual) { 
  if(!trigger) return
  const productsGrid = document.querySelector(".products-list-grid");
  const sectionId = trigger.getAttribute("data-section-id"); 
  const url = new URL(window.location.href); 
  if (sectionId) url.searchParams.set("section_id", sectionId);
  
  // Set the previous page in the fetch URL
  url.searchParams.set("page", previousPage);

  const browserUrl = new URL(window.location.href);
  browserUrl.searchParams.set("page", previousPage);
  if(!menual) window.history.replaceState({}, "", browserUrl.toString());
  trigger.classList.add("is-loading");

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Network error");

    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    const newContent = doc.querySelector(".products-list-grid"); 
    if (newContent) {
      // Prepend previous page products to the beginning
      Array.from(newContent.children).reverse().forEach((el) => {
        productsGrid.insertBefore(el, productsGrid.firstChild);
      });
      
      // Update trigger's current page attribute
      trigger.setAttribute("data-current-page", (previousPage - 1));
      
      // Hide button if we're at page 1
      if (previousPage === 1) {
        trigger.style.display = "none";
      }
    }
  } catch (err) {
    console.error("Failed to load previous products", err);
  } finally {
    setTimeout(() => {
      trigger.classList.remove("is-loading");
    }, 300);
  }
}

function setupInfiniteScroll() {
  const trigger = document.getElementById("infinite-scroll-trigger");
  if (!trigger) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadMoreProducts();
        }
      });
    },
    { threshold: 1 }
  );

  observer.observe(trigger);
}
async function loadPRProductsOnload() {
  const focusedItem = localStorage.getItem('focusedItem');

  if (!focusedItem || !window.template?.includes('collection')) return;

  const trigger = document.querySelector('.pgn-Loadprev');
  const previousPage = parseInt(trigger?.getAttribute('data-current-page'));

  await loadPreviousProducts(previousPage, trigger, true);

  // Wait for DOM + images + layout (Safari needs this)
      requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const targetSection = document.querySelector(
          `[data-card-url="${focusedItem}"]`
        );

        if (!targetSection) return;

        const rect = targetSection.getBoundingClientRect();

        // Force reflow for iOS
        rect.top;

        const scrollTop = window.pageYOffset;
        const viewportHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;

        let y = scrollTop + rect.top - viewportHeight / 3;

        // 🔑 CLAMP for iOS Safari
        const maxScroll = docHeight - viewportHeight;
        y = Math.max(0, Math.min(y, maxScroll));

        window.scrollTo({
          top: y,
          behavior: 'auto'
        });

        console.log('focusedItem', focusedItem);
        localStorage.removeItem('focusedItem');
      });
    });
   setTimeout(() => {
      window.scrollTo({ top: y, behavior: 'auto' });
    }, 100);

}

document.addEventListener("DOMContentLoaded", () => {
  setupInfiniteScroll();
  loadPRProductsOnload();
});
window.addEventListener('pageshow', function (event) { 
  loadPRProductsOnload(); 
});